import Link from 'next/link'

import { STRINGS } from '@/constants/farmerSolutions'
import useDownloadAppForm from '@/hooks/useDownloadAppForm'

interface ExternalLinkProps {
  title: string
  href: string
}

const ExternalLink = ({ title, href }: ExternalLinkProps) => (
  <Link
    href={href}
    rel="noreferrer"
    target="_blank"
    className="text-neutral-80 font-medium font-natosans-medium border-b border-neutral-80"
  >
    {title}
  </Link>
)

const DownloadApp = () => {
  const onSubmit = useDownloadAppForm()

  return (
    <section className="my-[100px] py-7 bg-[#ccefdb]">
      <section className="px-6 my-4 max-w-7xl m-auto flex md:items-center md:flex-row flex-col">
        <p className="md:text-5xl text-[28px] font-natosans-medium font-medium text-[#101010] leading-[1.1875] md:pr-4 md:w-1/2">
          {STRINGS.EXPERIENCE_FARMER_APP}
        </p>
        <section className="md:pt-8 pt-4 md:pl-4 md:w-1/2">
          <form onSubmit={onSubmit} className="flex md:flex-row flex-col">
            <input
              type="number"
              name="mobile_number"
              required
              aria-required
              placeholder={STRINGS.ENTER_MOBILE_NUMBER}
              className="md:h-[72px] h-[59px] md:rounded-r-none rounded-xl focus:outline-none max-w-[403px] w-full md:text-lg text-base px-[26px] py-[22px] text-neutral-80"
            />
            <button
              type="submit"
              className="bg-primary-100 md:rounded-l-none mt-6 md:mt-0 rounded-xl md:px-9 px-6 md:py-[22px] py-4 text-white font-natosans-medium font-medium md:text-lg text-base leading-[1.2] whitespace-nowrap max-w-[200px] text-center"
            >
              {STRINGS.DOWNLOAD_APP}
            </button>
          </form>
          <article className="text-[#666666] leading-[1.6] mt-2 text-[10px]">
            {STRINGS.BY_PROVIDING_NUMBER(
              <ExternalLink
                href="https://policies.agrevolution.in/terms-and-conditions/"
                title={STRINGS.TERM_AND_CONDITION}
              />,
              <ExternalLink
                href="https://policies.agrevolution.in/privacy-policy/"
                title={STRINGS.PRIVACY_POLICY}
              />
            )}
          </article>
        </section>
      </section>
    </section>
  )
}

export default DownloadApp
